import { render } from "./dropdown.vue?vue&type=template&id=bc896578&scoped=true"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"

import "./dropdown.vue?vue&type=style&index=0&id=bc896578&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc896578"]])

export default __exports__